//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Faq',
  data: function () {
    return {
      quest: "",
      isOpen: false,
    }
  },
  props: {
    idx: {
      type: Number,
      require: true
    },
    question: {
      type: String,
      require: true,
    },
    answer: {
      type: String,
      require: true
    }
  },
  methods: {
    toggleCollapse(idx) {
      if (this.quest != idx) {
        this.isOpen = true;
        this.quest = idx;
      }
      else {
        this.isOpen = !this.isOpen;
      }
    }
  },
}
